var juuls = juuls || {};
(function () {
    'use strict';
    juuls.pdf = {
        printWithDescription: true,
        printWithUserDescription: false,
        settings: juuls.pdfUtils.settings(),
        dimensions: {
            width: 535,
            height: 756.5
        },
        model: {
            get: function (key) {
                return juuls.pdfUtils.model.get(key, juuls.pdf.model);
            },
            set: function (key, value) {
                return juuls.pdfUtils.model.set(key, value, juuls.pdf.model);
            },
            logo: '',
            userLogo: '',
            name: '',
            number: '',
            price: '',
            beforePrice: '',
            discountPct: '',
            imagePrimary: {},
            descriptionLong: '',
            specs: [],
            topInfo: [],
            tastingNotes: {},
            rating: []
        },
        init: function () {
            juuls.pdf.bindEvents();
            juuls.pdf.userLogo.set();
        },
        bindEvents: function () {
            jQuery('.js-juuls-download-product-pdf').on('click', function () {
                juuls.pdf.printWithDescription = true;
                juuls.pdfUtils.loader(true);
                juuls.pdf.productData.get(false);
            });
            jQuery('.js-juuls-download-product-clean-pdf').on('click', function () {
                juuls.pdf.printWithDescription = false;
                juuls.pdfUtils.loader(true);
                juuls.pdf.productData.get(false);
            });
            jQuery('.js-pdf-logo-input').on('change', function (event) {
                juuls.pdf.userLogo.set(event, true);
            });
            jQuery('.js-pdf-alternative-logo-input').on('change', function (event) {
                juuls.pdf.userLogo.set(event, false);
            });
            jQuery('.js-pdf-logo-remove').on('click', function (event) {
                juuls.pdf.userLogo.reset(event, true);
            });
            jQuery('.js-pdf-alternative-logo-remove').on('click', function (event) {
                juuls.pdf.userLogo.reset(event, false);
            });
            jQuery('.js-juuls-download-product-price-pdf').on('click', function () {
                juuls.pdf.b2bModal.onSubmit();
            });
            jQuery('.js-pdf-description-toggle-off').on('click', function () {
                jQuery('#pdfUserDescriptionCollapse').collapse('hide');
            });
            jQuery('.js-pdf-description-toggle-on').on('click', function () {
                jQuery('#pdfUserDescriptionCollapse').collapse('show');
            });
        },
        productData: {
            get: function (submittedFormModal) {
                e4.jsonpublisher.getJsonFromUrl(e4.settings.ecom.pdf.url, jQuery('.js-e-product').data()).done(function (jsonData) {
                    juuls.pdf.productData.map(jsonData);
                    juuls.pdf.productData.extend(submittedFormModal);
                    juuls.pdfUtils.load(juuls.pdf.prepareImages.init);
                });
            },
            extend: function (submittedFormModal) {
                var tasteNotesObj = juuls.pdf.model.get('tastingNotes');
                if (jQuery.isEmptyObject(tasteNotesObj) === false) {
                    var returnValue = {};
                    Object.keys(tasteNotesObj).forEach(function (key) {
                        returnValue[key] = `/Files/Images/smagsnoter/${tasteNotesObj[key]}.png`;
                    });
                    juuls.pdf.model.set('tastingNotes', returnValue);
                }
                juuls.pdf.setDescription(submittedFormModal);
            },
            map: function (productData) {
                var productId = jQuery('.js-e-product').data('productId'),
                    extendPdfData = e4.data.get([
                        productId,
                        'PdfData'
                    ].join('_'));
                Object.assign(productData, extendPdfData);
                for (var key in productData) {
                    if (juuls.pdf.model.hasOwnProperty(key) === true) {
                        juuls.pdf.model.set(key, productData[key]);
                    }
                }
            }
        },
        prepareImages: {
            images: [],
            deferredImages: [],
            init: function () {
                var logo = {
                        key: 'logo',
                        img: juuls.pdf.model.get('logo'),
                        size: {
                            width: 200,
                            height: 0
                        }
                    },
                    userLogo = {
                        key: 'userLogo',
                        img: juuls.pdf.model.get('userLogo'),
                        size: {
                            width: 200,
                            height: 0
                        }
                    },
                    primaryImage = {
                        key: 'imagePrimary',
                        img: juuls.pdf.model.get('imagePrimary').original,
                        size: {
                            width: 0,
                            height: juuls.pdf.dimensions.height * 1.5,
                        }
                    },
                    tasteNotes = {
                        key: 'tastingNotes',
                        img: juuls.pdf.model.get('tastingNotes'),
                        size: {
                            width: 100,
                            height: 100
                        }
                    };
                juuls.pdfUtils.loader(true);
                if (juuls.pdfUtils.image.looksLikeDataUri(userLogo.img) === false) {
                    juuls.pdf.prepareImages.deferredImages.push(juuls.pdf.prepareImages.load(userLogo, false));
                }
                if (juuls.pdfUtils.image.looksLikeDataUri(logo.img) === false) {
                    juuls.pdf.prepareImages.deferredImages.push(juuls.pdf.prepareImages.load(logo, false));
                }
                if (juuls.pdfUtils.image.looksLikeDataUri(primaryImage.img) === false) {
                    juuls.pdf.prepareImages.deferredImages.push(juuls.pdf.prepareImages.load(primaryImage, false));
                }
                if (Object.keys(tasteNotes.img).length > 0) {
                    Object.keys(tasteNotes.img).forEach(function (imageKey) {
                        if (imageKey !== undefined && imageKey !== '') {
                            var imageObj = {
                                key: 'tastingNotes',
                                index: imageKey,
                                img: tasteNotes.img[imageKey],
                                size: tasteNotes.size
                            };
                            juuls.pdf.prepareImages.deferredImages.push(juuls.pdf.prepareImages.load(imageObj, false));
                        }
                    });
                }
                jQuery.when.apply(null, juuls.pdf.prepareImages.deferredImages).done(function () {
                    juuls.pdf.prepareImages.deferredImages = [];
                    juuls.pdf.build();
                });
            },
            load: function (imageObj, isSvg) {
                var image = new Image(),
                    deferred = jQuery.Deferred();
                if (isSvg === true) {
                    var serializer = new XMLSerializer();
                    jQuery.when(juuls.pdfUtils.image.convertSvg(imageObj.img)).done(function (svg) {
                        var cleanedSvg = juuls.pdf.prepareImages.updateSvg(svg.get(0));
                        juuls.pdf.prepareImages.images.push(cleanedSvg);

                        juuls.pdf.prepareImages.insertIntoModel(imageObj, serializer.serializeToString(cleanedSvg));
                        deferred.resolve();
                    });
                } else {
                    image.onload = function () {
                        var canvas = document.createElement('canvas');
                        canvas.width = this.naturalWidth === 0 ? imageObj.size.width : this.naturalWidth;
                        canvas.height = this.naturalHeight === 0 ? imageObj.size.height : this.naturalHeight;
                        canvas.getContext('2d').drawImage(this, 0, 0);
                        imageObj.size.width = image.width;
                        imageObj.size.height = image.height;

                        juuls.pdf.prepareImages.images.push(imageObj);
                        juuls.pdf.prepareImages.insertIntoModel(imageObj, canvas.toDataURL());
                        deferred.resolve();
                    };
                    image.onerror = function () {
                        var fallbackImage = juuls.pdfUtils.image.fallback();
                        juuls.pdf.prepareImages.insertIntoModel(imageObj, fallbackImage);
                        deferred.resolve();
                    };
                    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
                        image.width = imageObj.size.width;
                        image.height = imageObj.size.height;
                    }
                    image.src = juuls.pdfUtils.image.handler(imageObj.img, imageObj.size);
                }
                return deferred.promise();
            },
            insertIntoModel: function (imageObj, dataUri) {
                if (imageObj.index) {
                    imageObj.img = dataUri;
                    juuls.pdf.model.set(imageObj.key + '.' + imageObj.index, imageObj);
                } else {
                    juuls.pdf.model.set(imageObj.key, dataUri);
                }
            },
            updateSvg: function (svg) {
                var elements = svg.querySelectorAll('path, polyline, polygon');
                for (var i = 0; i < elements.length; i++) {
                    elements[i].setAttribute('style', 'fill:#6D6F70!important');
                }
                return svg;
            }
        },
        setDescription: function (submittedFormModal = false) {
            if (jQuery('.js-juuls-pdf-price-modal').length === 1 && submittedFormModal) {
                var jSelectedDescriptionOption = jQuery('.js-pdf-price-description').filter(':checked'),
                    strUserDescription = jQuery('.js-summernote-editor').summernote('code');
                juuls.pdf.printWithUserDescription = jSelectedDescriptionOption.val() === 'user';
                if (juuls.pdf.printWithUserDescription) {
                    juuls.pdf.model.set('descriptionLong', strUserDescription);
                } else {
                    juuls.pdf.printWithDescription = jSelectedDescriptionOption.val() === 'web';
                }
            } else {
                if (!juuls.pdf.model.get('descriptionLong') || juuls.pdf.model.get('descriptionLong') === 'null') {
                    juuls.pdf.printWithDescription = false;
                }
            }
        },
        userLogo: {
            set: function (event, shouldSaveUserLogo) {
                if (event) {
                    var domInput = event.target;
                    if (domInput.files && domInput.files[0]) {
                        var reader = new FileReader();
                        reader.onload = function (progressEvent) {
                            var imgElement = document.createElement('img');
                            imgElement.src = progressEvent.target.result;
                            var jFormElement = jQuery(domInput).closest('.js-pdf-logo-upload-form')
                            jFormElement.find('.js-pdf-logo-preview').append(imgElement).addClass('has-preview');
                            jFormElement.find('.js-pdf-logo-form').addClass('d-none');
                            juuls.pdf.model.set('userLogo', progressEvent.target.result);
                        };
                        reader.readAsDataURL(domInput.files[0]);
                        if (shouldSaveUserLogo === true) {
                            juuls.pdf.userLogo.save(domInput.files);
                        } else {
                            jQuery('.js-juuls-user-logo-image').addClass('img-muted');
                        }

                    }
                } else {
                    var jImageElement = jQuery('.js-juuls-user-logo-image');
                    if (jImageElement.length === 1) {
                        juuls.pdf.model.set('userLogo', jImageElement.attr('src'));
                    }
                }
            },
            save: function (files) {
                var formData = new FormData();
                formData.append('setUserLogo', 'true');
                formData.append('userLogo', files[0]);
                jQuery.ajax({
                    type: 'POST',
                    cache: false,
                    data: formData,
                    processData: false,
                    contentType: false,
                    beforeSend: function () {
                        jQuery('.js-juuls-price-modal-overlay').addClass('is-loading');
                    }
                }).done(function () {
                    jQuery('.js-juuls-price-modal-overlay').removeClass('is-loading');
                });
            },
            reset: function (event, shouldDeleteUserLogo) {
                var domInput = event.target,
                    jFormElement = jQuery(domInput).closest('.js-pdf-logo-upload-form'),
                    jPreview = jQuery(domInput).closest('.js-pdf-logo-preview');

                jFormElement.find('input[type="file"]').val('');
                jPreview.find('img').remove();
                jPreview.removeClass('has-preview');
                if (shouldDeleteUserLogo === true) {
                    juuls.pdf.model.set('userLogo', '');
                    jQuery.ajax({
                        data: {
                            unsetUserLogo: true
                        },
                        beforeSend: function () {
                            jQuery('.js-juuls-price-modal-overlay').addClass('is-loading');
                        }
                    }).done(function () {
                        jPreview.find('.js-pdf-logo-form').addClass('d-none');
                        jFormElement.find('.js-pdf-logo-form').removeClass('d-none');
                        jQuery('.js-juuls-price-modal-overlay').removeClass('is-loading');

                    });
                } else {
                    var jImageElement = jQuery('.js-juuls-user-logo-image');
                    juuls.pdf.model.set('userLogo', jImageElement.attr('src'));
                    jImageElement.removeClass('img-muted');
                }

            },
            alternative: function () {
            }
        },
        b2bModal: {
            onSubmit: function () {
                juuls.pdf.b2bModal.setPrice();
                jQuery('.js-juuls-pdf-price-modal').modal('hide');
                juuls.pdfUtils.loader(true);
                juuls.pdf.productData.get(true);
            },
            setPrice: function () {
                juuls.pdf.model.set('price', '');
                juuls.pdf.model.set('beforePrice', '');
                var strPrice = jQuery('.js-juuls-pdf-price').val(),
                    strBeforePrice = jQuery('.js-juuls-pdf-before-price').val();
                juuls.pdf.model.set('price', strPrice);
                juuls.pdf.model.set('beforePrice', strBeforePrice);
                if (strPrice !== '' && strBeforePrice !== '') {
                    juuls.pdf.b2bModal.setDiscountPct(strPrice, strBeforePrice);
                }
            },
            setDiscountPct: function (originalPriceStr, discountedPriceStr) {
                let discountPct = juuls.pdf.calculateDiscountPct(originalPriceStr, discountedPriceStr);
                if (discountPct > 0) {
                    juuls.pdf.model.set('discountPct', discountPct);
                }
            }
        },
        constructor: {
            price: function () {
                var price = juuls.pdf.model.get('price'),
                    beforePrice = juuls.pdf.model.get('beforePrice'),
                    hasPrice = price !== '',
                    hasBeforePrice = beforePrice !== '',
                    returnValue = {
                        text: ''
                    };
                if (hasPrice) {
                    returnValue = {
                        margin: [0, 15, 0, 0],
                        absolutePosition: {x: juuls.pdf.settings.pageMargins[0] + 20, y: juuls.pdf.dimensions.height - 115},
                        stack: [{
                            text: price,
                            fontSize: 28,
                            color: '#000',
                            bold: true,
                            alignment: 'left',
                            margin: [0, 0, 0, 0]
                        }]
                    };

                    if (hasBeforePrice) {
                        const original = juuls.pdf.cleanNumber(price);
                        const discounted = juuls.pdf.cleanNumber(beforePrice);
                        const currency = juuls.pdf.extractCurrency(price);
                        const diffPrice = juuls.pdf.formatPrice(Math.abs(original - discounted), 'da-DK', currency);

                        returnValue.stack.push({
                            columns: [
                                {
                                    width: 'auto',
                                    text: [
                                        {text: 'Spar '},
                                        {text: diffPrice, bold: true}
                                    ],
                                    fontSize: 14,
                                    color: '#4c7902',
                                    alignment: 'left',
                                    margin: [0, 0, 15, 0]
                                },
                                {
                                    text: 'Før pris ' + beforePrice,
                                    fontSize: 9,
                                    decoration: 'lineThrough',
                                    color: '#777',
                                    alignment: 'left',
                                    margin: [0, 4, 0, 0]
                                }
                            ],
                            margin: [0, 0, 0, 0]
                        });
                    }
                }
                return returnValue;
            },
            discountPctBadge: function () {
                let returnValue = {
                        text: ''
                    },
                    returnContent = [],
                    discountPct = juuls.pdf.model.get('discountPct');
                if (discountPct !== '') {

                    returnContent.push({
                        canvas: [
                            {
                                type: 'ellipse',
                                x: 40,
                                y: 40,
                                r1: 40,
                                r2: 40,
                                color: '#4c7902'
                            }
                        ],
                        absolutePosition: {x: 370, y: 30}
                    });
                    returnContent.push({
                        absolutePosition: {x: 255, y: 50},
                        stack: [
                            {
                                text: 'SPAR',
                                fontSize: 10,
                                color: '#fff',
                                bold: false,
                                alignment: 'center',
                                margin: [0, 0, 0, 0]
                            },
                            {
                                text: discountPct + '%',
                                fontSize: 24,
                                color: '#fff',
                                bold: true,
                                alignment: 'center',
                                margin: [0, -7, 0, 0]
                            }
                        ]
                    });

                    returnValue = returnContent;
                }
                return returnValue;
            },
            primaryImage: function () {
                let returnValue = {
                        text: ''
                    },
                    imagePrimary = juuls.pdf.prepareImages.images.find(item => item.key === "imagePrimary");

                if (imagePrimary !== undefined) {
                    const canvasWidth = Math.min(juuls.pdf.dimensions.width * .35) + juuls.pdf.settings.pageMargins[2];
                    const targetHeight = Math.min(juuls.pdf.dimensions.height * 0.8);
                    const computedImageSize = juuls.pdf.calculateImageSize(imagePrimary.size, null, targetHeight);
                    const targetWidth = computedImageSize.width;
                    let imageX = (canvasWidth - targetWidth) / 2;
                    const absoluteYPosition = (juuls.pdf.dimensions.height + juuls.pdf.settings.pageMargins[1]) - computedImageSize.height - 70;
                    const absoluteXPosition = (juuls.pdf.dimensions.width + juuls.pdf.settings.pageMargins[0]) - (canvasWidth - juuls.pdf.settings.pageMargins[2]);

                    let imageSvg = `<svg width="${canvasWidth}" height="${computedImageSize.height}" xmlns="http://www.w3.org/2000/svg">
                                <image x="${imageX}" y="18" width="${computedImageSize.width}" height="${computedImageSize.height}" href="${juuls.pdf.model.get('imagePrimary')}" />
                                </svg>`;
                    returnValue = {
                        svg: imageSvg,
                        absolutePosition: {x: absoluteXPosition, y: absoluteYPosition}
                    };
                }
                return returnValue;
            },
            userLogo: function () {
                var returnValue = {
                        text: ''
                    },
                    userLogo = juuls.pdf.model.get('userLogo'),
                    userLogoSrc = userLogo.hasOwnProperty('img') ? userLogo.img : userLogo;
                if (userLogoSrc !== '') {
                    const fitHeight = 60;
                    const absoluteYPosition = (juuls.pdf.dimensions.height + juuls.pdf.settings.pageMargins[1]) - fitHeight;
                    const absoluteXPosition = juuls.pdf.settings.pageMargins[1];

                    var image = {
                        image: userLogoSrc,
                        fit: [200, fitHeight],
                        margin: [0, 0, 0, 0],
                        alignment: 'left',
                        absolutePosition: {x: absoluteXPosition, y: absoluteYPosition}
                    };

                    returnValue = image;
                }
                return returnValue;
            },
            juulsLogo: function () {
                let returnValue = {
                        text: ''
                    },
                    logo = juuls.pdf.prepareImages.images.find(item => item.key === "logo");

                if (logo !== undefined) {
                    const computedImageSize = juuls.pdf.calculateImageSize(logo.size, null, 25);
                    returnValue = {
                        svg: `<svg width="${computedImageSize.height}" height="${computedImageSize.width}" xmlns="http://www.w3.org/2000/svg">
                                <image x="-${computedImageSize.width}" y="0" transform="rotate(270, 0, 0)" width="${computedImageSize.width}" height="${computedImageSize.height}" href="${juuls.pdf.model.get('logo')}" />
                                </svg>`,
                        absolutePosition: {
                            x: juuls.pdf.dimensions.width,
                            y: juuls.pdf.settings.pageMargins[1]
                        }
                    };
                }
                return returnValue;
            },
            productNumber: function () {
                let logo = juuls.pdf.prepareImages.images.find(item => item.key === "logo");
                let absoluteYPosition = juuls.pdf.settings.pageMargins[1];
                if (logo !== undefined) {
                    const computedImageSize = juuls.pdf.calculateImageSize(logo.size, null, 25);
                    absoluteYPosition += computedImageSize.width + 20;
                }
                let svg = `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="200">
                                <text 
                                  x="0" 
                                  y="14" 
                                  transform="rotate(270, 0, 0)" 
                                  font-size="10" 
                                  fill="black"
                                  text-anchor="end"
                                  dominant-baseline="text-before-edge">
                                  Varenummer: ${juuls.pdf.model.get('number')}
                                </text>
                              </svg>`;

                let returnValue = {
                    svg: svg,
                    absolutePosition: {
                        x: juuls.pdf.dimensions.width,
                        y: absoluteYPosition
                    }
                };
                return returnValue;
            },
            rating: function () {
                var ratings = juuls.pdf.model.get('rating'),
                    returnValue = [],
                    widths = [];
                ratings.forEach(function (ratingObj) {
                    if (ratingObj.value !== '') {
                        var ratingDashOffset = 0;
                        switch (ratingObj.value) {
                            case '1':
                                ratingDashOffset = 180.956;
                                break;
                            case '2':
                                ratingDashOffset = 135.717;
                                break;
                            case '3':
                                ratingDashOffset = 90.4779;
                                break;
                            case '4':
                                ratingDashOffset = 45.2389;
                                break;
                            case '5':
                                ratingDashOffset = 0;
                                break;
                            default:
                                ratingDashOffset = 226.195;
                                break;
                        }

                        var svg = `<svg viewBox="0 0 100 55" class="progress-ring" width="100" height="55" >
                             <defs>
                             <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                             <stop offset="0%" stop-color="#FCFBFB"></stop>
                             <stop offset="100%" stop-color="#f1edec"></stop>
                             </linearGradient>
                             </defs>
                             <g transform="scale(0.5)">
                             <circle class="progress-ring__circle__underlying" stroke="url(#gradient)" stroke-width="14" fill="transparent" r="36" cx="45" cy="45"></circle>
                             <circle transform="rotate(-90, 45, 45)" class="progress-ring__circle" stroke="#9d1915" stroke-width="14" stroke-dasharray="226.195, 226.195" stroke-dashoffset="${ratingDashOffset}" fill="transparent" r="36" cx="45" cy="45" ></circle>
                             <text x="45%" y="86%" dominant-baseline="middle" text-anchor="middle" font-size="11px">${ratingObj.value} af 5</text>
                             <text x="45%" y="190%" dominant-baseline="middle" text-anchor="middle" font-size="11px">${ratingObj.label}</text>
                             </g>
                             </svg>`;
                        returnValue.push({
                            margin: [
                                0,
                                0,
                                0,
                                0
                            ],
                            svg: svg
                        });
                        widths.push(50);
                    }
                });
                return {
                    layout: juuls.pdfUtils.cleanTableLayout(),
                    margin: [
                        0,
                        0,
                        0,
                        0
                    ],
                    table: {
                        widths: widths,
                        body: [
                            returnValue
                        ]
                    }
                }
            },
            tastingNotes: function () {
                var tastingNotes = juuls.pdf.model.get('tastingNotes'),
                    returnValue = [];
                Object.keys(tastingNotes).forEach(function (key) {
                    returnValue.push({
                        stack: [
                            juuls.pdfUtils.build.image(tastingNotes[key].img, 50, [
                                0,
                                0,
                                0,
                                0
                            ], 'center'),
                            {
                                style: 'tastenote',
                                text: tastingNotes[key].index
                            }
                        ],
                        margin: [
                            0,
                            0,
                            5,
                            0
                        ]
                    })
                })
                return {
                    layout: juuls.pdfUtils.cleanTableLayout(),
                    margin: [
                        0,
                        20,
                        0,
                        0
                    ],
                    table: {
                        body: [
                            returnValue
                        ]
                    }
                }
            },
            topInfo: function () {
                var topInfoArr = juuls.pdf.model.get('topInfo'),
                    returnValue = [];
                topInfoArr.forEach(function (topInfoElem) {
                    if (topInfoElem.value !== '') {
                        let strValue = topInfoElem.value;
                        if (topInfoElem.id === 'NAVWineEthanol') {
                            strValue = strValue + '%';
                        } else if (topInfoElem.id === 'NAVBaseUnit') {
                            strValue = topInfoElem.options[topInfoElem.value[0]]
                        }
                        returnValue.push(strValue);
                    }
                });
                return returnValue.join(' • ');
            },
            specs: function () {
                var specs = juuls.pdf.model.get('specs'),
                    returnValue = [];
                specs.forEach(function (specObj) {
                    if (specObj.value !== '') {
                        var strValue = specObj.value;
                        if (specObj.id === 'NAVWineEthanol') {
                            strValue = strValue + '%';
                        } else if (specObj.id === 'NAVBaseUnit') {
                            strValue = specObj.options[specObj.value[0]]
                        }
                        returnValue.push([
                            specObj.label,
                            strValue,
                        ]);
                    }
                });
                return {
                    layout: juuls.pdfUtils.cleanTableLayout(),
                    margin: [0, 0, 0, 0],
                    style: 'table',
                    fontSize: 6,
                    table: {
                        widths: [
                            '*',
                            '*'
                        ],
                        body: returnValue
                    }
                }
            }
        },
        build: function () {
            var arrPdf = [];
            var objContent = [];

            objContent.push({
                layout: juuls.pdfUtils.cleanTableLayout(),
                columns: [
                    {
                        width: '65%',
                        margin: [0, 0, 0, 0],
                        layout: juuls.pdfUtils.cleanTableLayout(),
                        table: {
                            widths: ['*'],
                            body: [
                                [
                                    {
                                        stack: [
                                            {
                                                text: juuls.pdf.model.get('name'),
                                                style: 'productName',
                                                margin: [0, 0, 0, 10]
                                            }
                                        ],
                                        margin: [15, 15, 15, 15]
                                    }
                                ]
                            ]
                        }
                    },
                    {
                        width: '*',
                        stack: []
                    }
                ]
            });

            const firstColumn = objContent[0].columns[0].table.body[0][0].stack;
            const secondColumn = objContent[0].columns[1].stack;

            secondColumn.push(juuls.pdf.constructor.primaryImage());

            objContent.push(juuls.pdf.constructor.productNumber());
            objContent.push(juuls.pdf.constructor.discountPctBadge());
            objContent.push(juuls.pdf.constructor.juulsLogo());

            if (juuls.pdf.printWithDescription === true || juuls.pdf.printWithUserDescription === true) {
                if (juuls.pdf.printWithUserDescription === false) {
                    firstColumn.push({
                        style: 'header',
                        margin: [
                            0,
                            0,
                            0,
                            0
                        ],
                        text: 'Beskrivelse'
                    });
                }

                let descriptionTable = {
                    layout: 'noBorders',
                    table: {
                        widths: ['*'],
                        body: [[{
                            stack: [],
                            height: 600
                        }]]
                    }
                };

                let description = htmlToPdfmake(juuls.pdf.model.get('descriptionLong'), {
                    defaultStyles: {
                        p: {
                            margin: [0, 0, 0, 10],
                            fontColor: '#666666',
                            fontSize: 8

                        },
                    }
                });


                descriptionTable.table.body[0][0].stack.push(description);
                firstColumn.push(descriptionTable);
            }
            
            let tableColumnWidth = ((juuls.pdf.dimensions.width * .65) - juuls.pdf.settings.pageMargins[0] - juuls.pdf.settings.pageMargins[2]) / 2;

            firstColumn.push({
                margin: [0, 30, 0, 0],
                table: {
                    widths: [tableColumnWidth, tableColumnWidth],
                    body: [
                        [
                            {
                                ...juuls.pdf.constructor.specs(),
                                valign: 'middle',
                                margin: [0, 15, 0, 15]
                            },
                            {
                                ...juuls.pdf.constructor.rating(),
                                valign: 'middle',
                                margin: [0, 15, 0, 15]
                            }
                        ]
                    ]
                },
                absolutePosition: {x: juuls.pdf.settings.pageMargins[0] + 20, y: juuls.pdf.dimensions.height - 220},
                layout: {
                    hLineWidth: function (i, node) {
                        if (i === 0 || i === node.table.body.length) return .25;
                        return 0;
                    },
                    vLineWidth: function () {
                        return 0;
                    },
                    hLineColor: function () {
                        return '#999999';
                    }
                }
            });

            firstColumn.push(juuls.pdf.constructor.price());
            objContent.push(juuls.pdf.constructor.userLogo());

            arrPdf.push(objContent);
            juuls.pdf.create(arrPdf);
        },
        create: function (arrPdf) {
            pdfMake.fonts = juuls.pdfUtils.setFont();

            const docDefinition = {
                pageSize: 'A4',
                pageMargins: juuls.pdf.settings.pageMargins,
                background: function (currentPage, pageSize) {
                    return {
                        canvas: [
                            {
                                type: 'rect',
                                x: juuls.pdf.settings.pageMargins[0],
                                y: juuls.pdf.settings.pageMargins[1],
                                w: Math.min(juuls.pdf.dimensions.width * .65),
                                h: juuls.pdf.dimensions.height - 70,
                                color: '#f1edec'
                            }
                        ]
                    };
                },
                content: arrPdf,
                fonts: juuls.pdfUtils.setFont(),
                defaultStyle: {
                    font: juuls.pdf.settings.defaultFont
                },
                styles: juuls.pdfUtils.styles.default()
            };

            var pdfDocGenerator = pdfMake.createPdf(docDefinition, null, juuls.pdfUtils.setFont());
            pdfDocGenerator.download(juuls.pdf.model.get('name').replace(/ /g, '_') + '.pdf');
            pdfDocGenerator.getDataUrl(function () {
                juuls.pdfUtils.loader(false);
            });
        },
        cleanNumber: function (input) {
            if (typeof input !== 'string') input = String(input);
            input = input.trim();

            if (input.includes(',') && input.includes('.')) {
                if (input.indexOf(',') > input.indexOf('.')) {
                    input = input.replace(/\./g, '').replace(',', '.');
                } else {
                    input = input.replace(/,/g, '');
                }
            } else if (input.includes(',')) {
                input = input.replace(',', '.');
            } else {
                input = input.replace(/,/g, '');
            }

            const num = parseFloat(input);
            if (isNaN(num)) throw new Error(`Invalid number: "${input}"`);
            return num;
        },
        calculateDiscountPct: function (originalPriceStr, discountedPriceStr) {
            const original = juuls.pdf.cleanNumber(originalPriceStr);
            const discounted = juuls.pdf.cleanNumber(discountedPriceStr);
            if (original <= 0 || discounted <= 0) return 0;
            const pct = ((original - discounted) / original) * 100;
            return parseInt(Math.round(Math.abs(pct) * 100) / 100);
        },
        extractCurrency(str) {
            const match = str.match(/[a-zA-Z]+/g);
            if (!match) return null;
            return match[match.length - 1];
        },
        formatPrice: function (value, locale = 'da-DK', currency = 'DKK') {
            return new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: currency,
                currencyDisplay: 'code',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(value);
        },
        calculateImageSize: function (imageOriginalSize, targetWidth, targetHeight) {
            let _targetHeight = 0;
            let _targetWidth = 0;
            if (targetHeight === null && targetWidth !== null) {
                _targetHeight = (targetWidth / imageOriginalSize.width) * imageOriginalSize.height;
                _targetWidth = targetWidth;
            }

            if (targetWidth === null && targetHeight !== null) {
                _targetHeight = targetHeight;
                _targetWidth = (targetHeight / imageOriginalSize.height) * imageOriginalSize.width;
            }

            return {
                height: Math.min(_targetHeight),
                width: Math.min(_targetWidth)
            }
        }
    };
}());